import { useState, useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router";
import { hookupConfig as defaultConfig } from "./HookupConfig";
import { setDynamicColumnAndBaseData } from "./ParametreSetsForm";
import CommonUiModel from "../common/commonUiModel";

function HookupConfigForm() {
    const { equipmentId, equipmentScopeId } = useParams();
    const [state, setState] = useState({ formConfig: null, baseData: {}});
    useEffect(() => {
        if(!equipmentId && !equipmentScopeId) {
            return;
        }
        const deepCopiedConfig = { ...defaultConfig, columns: [...defaultConfig.columns.map(col => ({ ...col }))] };
        setDynamicColumnAndBaseData({ defaultConfig: deepCopiedConfig, setState, equipmentId, equipmentScopeId, formName: "Hookup" });
    }, [equipmentId, equipmentScopeId]);

    const HookupForm = useMemo(() => {
        if (!state.formConfig) return null;
        return new CommonUiModel(state.formConfig);
    }, [state.formConfig]);

    if (!HookupForm) return null;

    return (
        <Box>
            <HookupForm.Form baseSaveData={{
                EquipmentScopeId: parseInt(equipmentScopeId),
                ...state.baseData
            }} />
        </Box>
    );
}

export default HookupConfigForm;